var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      { staticClass: "row justify-content-center no-gutters mb-4" },
      [
        _c(
          "section-error",
          {
            staticClass: "row form-container radio-form grid-form mx-0",
            attrs: { tag: "div", icon: false },
          },
          _vm._l(_vm.options, function (option) {
            return _c(
              "div",
              {
                key: _vm.radioId(option.value),
                class:
                  "property-option d-flex align-items-center flex-column " +
                  _vm.squaresSize +
                  " " +
                  _vm.optionsSizeClass,
                style: _vm.recommendedBrowser()
                  ? ""
                  : "margin-right: 3rem; margin-left:3rem",
              },
              [
                _c("input", {
                  class: _vm.className,
                  attrs: {
                    id: _vm.radioId(option.value),
                    type: "radio",
                    name: _vm.path + "[" + _vm.name + "]",
                    disabled: _vm.disabled,
                  },
                  domProps: {
                    checked: _vm.checked === option.value,
                    value: option.value,
                  },
                  on: { change: _vm.handleInput },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-property",
                  attrs: {
                    src: _vm.getImgUrl(option.imgSrc),
                    alt: _vm._f("getSchemaTranslation")(
                      option.label,
                      _vm.translationMap
                    ),
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: _vm.radioId(option.value) } }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("getSchemaTranslation")(
                        option.label,
                        _vm.translationMap
                      )
                    )
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }